import { render, staticRenderFns } from "./DuelsCreate.vue?vue&type=template&id=1415c10a&scoped=true&lang=pug"
import script from "./DuelsCreate.vue?vue&type=script&lang=js"
export * from "./DuelsCreate.vue?vue&type=script&lang=js"
import style0 from "./DuelsCreate.vue?vue&type=style&index=0&id=1415c10a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1415c10a",
  null
  
)

export default component.exports